import React, { FC } from 'react'

import { IconFilter } from '@avantstay/backoffice-vectors'

import { useIsTabletOrMobile } from '../../utils/mediaQueries'
import { Tooltip } from '../Tooltip/Tooltip'
import * as S from './FiltersButton.styles'

interface FiltersButtonProps {
  onClick: VoidFunction
  activeFiltersLength: number
  isActive: boolean
  label?: string
  buttonHeight?: number
  buttonWidth?: number
  tooltipDisabled?: boolean
  className?: string
}

export const FiltersButton: FC<FiltersButtonProps> = ({
  activeFiltersLength,
  className,
  isActive,
  onClick,
  label,
  buttonHeight,
  buttonWidth,
  tooltipDisabled,
}) => {
  const isActiveFilter = activeFiltersLength > 0
  const isTabletOrMobile = useIsTabletOrMobile()

  const buttonRender = () => (
    <S.FilterButton
      className={className}
      isActive={isActive}
      isFilterActive={isActiveFilter}
      onClick={onClick}
      buttonHeight={buttonHeight}
      buttonWidth={buttonWidth}
    >
      <S.IndicatorContainer>
        {label && <S.Label isActive={isActive}>{label}</S.Label>}

        <S.ActiveFilterIndicator hasActiveFilter={isActiveFilter} isActive={isActive}>
          {activeFiltersLength}
        </S.ActiveFilterIndicator>
        <IconFilter />
      </S.IndicatorContainer>
    </S.FilterButton>
  )

  return tooltipDisabled ? (
    buttonRender()
  ) : (
    <Tooltip
      disabled={isTabletOrMobile}
      content={`${isActive ? 'Close' : 'Open'} filters`}
      placement="top"
    >
      {buttonRender()}
    </Tooltip>
  )
}
